import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "step__one" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите фамилию", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите имя", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Загрузите или перенесите сюда файл подписи", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "right",
  style: {"margin-top":"-11px","justify-content":"initial"}
}
const _hoisted_8 = {
  class: "gender",
  style: {"margin-top":"24px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "gender" }, "Выберите пол", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUploadMini = _resolveComponent("FileUploadMini")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Введите фамилию",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document.signatory_lastname) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.signatory_lastname]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Введите имя",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.signatory_firstname) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.signatory_firstname]
        ])
      ]),
      _createElementVNode("section", null, [
        _hoisted_5,
        _createVNode(_component_FileUploadMini, {
          document: _ctx.document,
          file_upload_name: 'signatory_file',
          upload_text: 'Подпись должны быть на прозрачном фоне в формате png'
        }, null, 8, ["document"])
      ]),
      (_ctx.document.signatory_parent != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              style: {"width":"83px","height":"46px","position":"absolute","top":"779px","border-radius":"4px","margin-left":"0px","font-size":"14px","background-color":"#2F80ED","color":"white"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.go_doc && _ctx.go_doc(...args)))
            }, "Назад")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("section", null, [
        _createVNode(_component_v_switch, {
          style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
          color: "#2F80ED",
          modelValue: _ctx.document.signatory_skip_patronymic,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.signatory_skip_patronymic) = $event)),
          label: "Отчество"
        }, null, 8, ["modelValue"]),
        _withDirectives(_createElementVNode("input", {
          class: "input lastname",
          type: "text",
          placeholder: "Введите отчество",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.signatory_patronymic) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.signatory_patronymic]
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_v_radio_group, {
          modelValue: _ctx.document.signatory_genre,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.signatory_genre) = $event)),
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_radio, {
              color: "#2F80ED",
              label: "Мужчина",
              value: "1"
            }),
            _createVNode(_component_v_radio, {
              color: "#2F80ED",
              label: "Женщина",
              value: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}